<template>
  <h1 style="white-space: pre;" v-text="title"></h1>
</template>

<script>

export default {
  name: "TitleLabel",
  data: () => ({
  }),
  methods: {
  },
  components: {
  },
  props: ['title']
};

</script>

<style scoped>
h1 {
  color: #fff;
  margin-bottom: 40px;
}
@media screen and (max-width: 350px) {
  h1 {
    font-size: 1.1em;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
  h1 {
    font-size: 1.2em;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  h1 {
    font-size: 1.8em;
  }
}
@media screen and (min-width: 1024px) {
  h1 {
    font-size: 2em;
  }
}
</style>
